// Query keys for the per-step process data a run page reads. Kept in a plain
// module so the form-level batch read (lib/processRunBatch.ts) fills exactly
// the keys the per-field hooks read, and both can be unit-tested without React.

/**
 * Query key for a field's connection: ['process-steps', tenantId, fieldId] —
 * plus the submission when the step is read as a RUN, because the quantities
 * differ. Without it a step opened inside a batched run would be served the
 * builder's cached per-unit copy, or vice versa. The builder's invalidations
 * pass the 3-element prefix, which still matches these longer keys.
 */
export const connectionKey = (
  tenantId: string | null,
  fieldId: string | null,
  submissionId?: string | null,
): readonly unknown[] =>
  submissionId
    ? (['process-steps', tenantId, fieldId, 'run', submissionId] as const)
    : (['process-steps', tenantId, fieldId] as const)

/** Query key for a step's live equipment holds on one submission. */
export const reservationsKey = (
  tenantId: string | null,
  submissionId: string | null,
  fieldId: string | null,
) => ['process-steps', tenantId, 'reservations', submissionId, fieldId] as const

/** Query key for a step's Assign To roster (null field id = the whole roster). */
export const processAssignableUsersKey = (tenantId: string | null, fieldId?: string | null) =>
  ['process-assignable-users', tenantId, fieldId ?? null] as const
